import styled, { css } from 'styled-components'
import { TiArrowSortedUp, TiArrowSortedDown } from 'react-icons/ti'
import { AiFillStar } from 'react-icons/ai'
import { motion } from 'framer-motion'

const Wrapper = styled.div`
	height: 100%;
	width: 100%;
	display: flex;
	flex-direction: column;
	position: relative;
`

const TableWrapper = styled.div`
	&::-webkit-scrollbar-track {
		box-shadow: inset 0 0 5px ${(props) => props.theme.mainBg};
	}
`

const HeaderWrapper = styled.div`
	//padding: 10px 10px 4px 10px;
`

const Headers = styled.div`
	width: 100%;
	margin-top: 10px;
	display: flex;
	align-items: center;
`

const Favorite = styled(AiFillStar)`
	size: 12px;
	margin-right: ${(props) => (props.header && '15px') || '5px'};
	margin-left: ${(props) => (props.header && 0) || '5px'};
	color: ${(props) => (props.active && props.theme.active) || props.theme.color};
	margin-bottom: 2px;
	cursor: pointer;
	transition: all 0.2s;

	&:hover {
		color: ${(props) => props.theme.active};
	}
`

const HeaderText = styled.div`
	text-align: center;
	color: ${(props) => (props.active && props.theme.active) || props.theme.color};
	font-size: 0.8rem;
	font-weight: 600;
	margin-right: 15px;
	cursor: pointer;
	transition: all 0.2s;

	&:hover {
		color: ${(props) => props.theme.active};
	}

	@media screen and (max-width: 1400px) {
		font-size: 0.6rem;
	}
`

const Row = styled.div`
	width: 100%;
	display: flex;
	padding: 4px 10px;
	cursor: ${(props) => !props.header && 'pointer'};

	&:hover {
		background-color: ${(props) => !props.header && '#848e9c70'};
	}
`

const Column = styled.div`
	width: ${({ index }) => (index === 0 || index === 1 ? '35%' : '30%')};
	justify-content: ${({ index, theme }) => {
		if (index === 2) {
			return theme.english ? 'flex-end' : 'flex-start'
		} else if (index === 1) {
			return 'flex-end'
		} else {
			return 'flex-start'
		}
	}};
	${(props) =>
		props.index === 2 &&
		css`
			direction: ltr;
		`}
	${(props) =>
		props.index === 2 &&
		!props.header &&
		css`
			padding: 0 10px;
		`}
  display: flex;
	font-size: 0.7rem;
	color: ${(props) =>
		props.definedColor
			? props.definedColor === 'green'
				? props.theme.mainGreen
				: props.theme.mainRed
			: props.theme.color};
	font-family: ${(props) => props.index !== 0 && !props.header && 'monospace !important'};
	//font-weight: ${(props) => props.index !== 0 && !props.header && 600};

	${(props) =>
		props.index === 0 &&
		css`
			font-size: 0.75rem;
		`};

	@media screen and (max-width: 1400px) {
		font-size: 0.7rem;
	}
`

const Flex = styled.div`
	display: flex;
	align-items: center;
	cursor: pointer;
`

const FirstPart = styled.div`
	color: ${(props) => props.theme.secondary};
`

const FlexColumn = styled.div`
	display: flex;
	flex-direction: column;
`

const SortUpArrow = styled(TiArrowSortedUp)`
	size: 6px;
	margin-bottom: -3.5px;
	color: ${(props) => (props.active && props.theme.active) || props.theme.color};
`

const SortDownArrow = styled(TiArrowSortedDown)`
	size: 6px;
	margin-top: -3.5px;
	color: ${(props) => (props.active && props.theme.active) || props.theme.color};
`

const SpinnerBody = styled.div`
	position: absolute;
	width: 100%;
	height: 100%;
	left: 0;
	top: 0;
	display: flex;
	align-items: center;
	justify-content: center;
`

const PairsTabletBox = styled(motion.div)`
	position: absolute;
	${(props) =>
		props.theme.english &&
		css`
			left: 0;
		`};
	${(props) =>
		!props.theme.english &&
		css`
			right: 0;
		`};
	top: 60px;
	z-index: 10;
	min-width: 340px;
	height: fit-content;
`

const PairsMobileBox = styled(PairsTabletBox)`
	${(props) =>
		props.theme.english &&
		css`
			right: 0;
		`};
	${(props) =>
		!props.theme.english &&
		css`
			left: 0;
		`};
	top: 50px;
	width: fit-content;

	@media screen and (max-width: 768px) {
		width: 100%;
	}
`

export {
	Row,
	Column,
	TableWrapper,
	Wrapper,
	HeaderText,
	HeaderWrapper,
	Headers,
	Favorite,
	Flex,
	FirstPart,
	FlexColumn,
	SortUpArrow,
	SortDownArrow,
	SpinnerBody,
	PairsTabletBox,
	PairsMobileBox,
}
